import { getAppList } from '@/api/getApp'

const platFormApp = {
  state: {
    list: []
  },
  mutations: {
    SET_LIST: (state, list) => {
      state.list = list;
    }
  },
  actions: {
    GetPlatFormApp({commit, state}) {
      return new Promise((resolve, reject) => {
        getAppList({nodeId: this.getters.objApi.NODE_ID}).then(res => {
          commit('SET_LIST', res.data);
          resolve(res.data);
        }).catch(error => {
          reject(error);
        })
      })
    }
  }
}

export default platFormApp;



// WEBPACK FOOTER //
// ./src/store/modules/platform.js